import React from "react";

export default function WolfBannerSong() {
  return (
    <>
      <p class="c2">
        <span>
          <p>The woods are thick, the bows are drawn, </p>
          <p>Our strength is quiet, but it’s not gone.</p>
          <p>The wolves will run, the horns will sound,</p>
          <p>The people rise to hold their ground. </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Through ash and flame, we still defend,</p>
          <p>For home, we fight until the end.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Bend the bow,</p>
          <p>Loose the string,</p>
          <p>For every blow, the echoes ring.</p>
          <p>Through the storm, we'll stand as one,</p>
          <p>The wheel will turn, but we're not done.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The mountain wind, it whispers low,</p>
          <p>Through fields of grain, through winter’s snow.</p>
          <p>A hammer’s weight, a leader’s call,</p>
          <p>The stoutest hearts will never fall.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Through ash and flame, we still defend,</p>
          <p>For home, we fight until the end.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Bend the bow,</p>
          <p>Loose the string,</p>
          <p>For every blow, the echoes ring.</p>
          <p>Through the storm, we'll stand as one,</p>
          <p>The wheel will turn, but we're not done.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>With ashwood bows and iron pride,</p>
          <p>The Two Rivers will turn the tide.</p>
          <p>Through Perrin’s howl, through every fight,</p>
          <p>Our land will stand, we’ll guard the light.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Bend the bow,</p>
          <p>Loose the string,</p>
          <p>For every blow, the echoes ring.</p>
          <p>Through the storm, we'll stand as one,</p>
          <p>The wheel will turn, but we're not done.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The wheel will turn, but we’re not done,</p>
          <p>We’ll guard the light until it’s won.</p>
        </span>
      </p>
    </>
  );
}
